import type { PepRca } from "@/models/persons/pepRca";
import { createEmptyPepRcaRoleAndCountry } from "@/models/persons/pepRca";

export interface AnswerPersonWithPepAndSanctions
  extends PersonWithPepAndSanctions {}

export interface PersonWithPepAndSanctions {
  name: string;
  surname: string;
  birth: string;
  nationality: string;
  pepRca: PepRca;
  subjectToSanctions: string;
}

export function createEmptyPersonWithPepAndSanctions(): PersonWithPepAndSanctions {
  return {
    name: "",
    surname: "",
    birth: "",
    nationality: "",
    pepRca: {
      isPepRca: "",
      pepRcaRoleAndCountry: [createEmptyPepRcaRoleAndCountry()],
    },
    subjectToSanctions: "",
  };
}
